export function generateCorrelationId(): string {
  // RFC4122-ish simple GUID generator fallback
  return ([1e7] as any)+-1e3+-4e3+-8e3+-1e11 as unknown as string;
}

export async function fetchJson(input: RequestInfo | URL, init: RequestInit = {}) {
  const headers = new Headers(init.headers || {});
  if (!headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  if (!headers.has('x-correlation-id')) headers.set('x-correlation-id', generateCorrelationId());
  const res = await fetch(input, { ...init, headers });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `HTTP ${res.status}`);
  }
  const ct = res.headers.get('content-type') || '';
  return ct.includes('application/json') ? res.json() : res.text();
}


